if (!customElements.get('pawty-portrait-type-v2')) {
  customElements.define('pawty-portrait-type-v2', class extends HTMLElement {
    connectedCallback() {
      const fieldset = this.querySelector('.pawty-type');
      if (!fieldset) return;
      const portrait = new URLSearchParams(window.location.search).get('portrait');
      this.inputs = this.querySelectorAll('input[type="radio"]');
      this.media = document.querySelector('.product-information__media');
      this.settings = fieldset.dataset;
      this.isCreateYourOwn = this.settings.createOwn === 'true';
      this.usesNativeVariants = this.settings.nativeVariants === 'true';
      this.variantPicker = document.querySelector('variant-picker');
      this.nativeTypeInputs = Array.from(this.variantPicker?.querySelectorAll('input[type="radio"]') || []).filter((input) => ['Multi-Pet', 'Pet & Human', 'Single Pet / Memorial'].includes(input.value));
      this.nativeSubjectInputs = Array.from(this.variantPicker?.querySelectorAll('input[type="radio"]') || []).filter((input) => /^\d+$/.test(input.value));
      try {
        this.nativeVariants = JSON.parse(this.querySelector('[data-pawty-native-variants]')?.textContent || '[]');
      } catch (_) {
        this.nativeVariants = [];
      }
      this.inspirationSettings = this.querySelector('.pawty-inspiration-data')?.dataset || {};
      this.galleryInvite = this.querySelector('.pawty-product-gallery-invite');
      this.fieldsetHome = document.createComment('pawty-portrait-type-home');
      fieldset.before(this.fieldsetHome);
      if (this.isCreateYourOwn && !this.usesNativeVariants) this.setupInspiration(fieldset);
      if (this.isCreateYourOwn && !this.usesNativeVariants && this.media && !this.media.querySelector('.pawty-media-switcher')) {
        this.viewer = document.createElement('div');
        this.viewer.className = 'pawty-media-switcher';
        this.viewer.innerHTML = '<img alt=""><span class="pawty-media-switcher__label"></span>';
        this.media.appendChild(this.viewer);
      } else if (this.isCreateYourOwn && !this.usesNativeVariants && this.media) {
        this.viewer = this.media.querySelector('.pawty-media-switcher');
      }
      this.mobileQuery = window.matchMedia('(max-width: 749px)');
      this.positionFieldset = () => {
        const mediaAnchor = this.viewer || (this.usesNativeVariants ? this.media?.querySelector('media-gallery') : null);
        const moveBelowImage = this.mobileQuery.matches && mediaAnchor;
        const prompt = this.inspirationCard || this.galleryInvite;
        if (moveBelowImage) {
          mediaAnchor.after(prompt || fieldset);
          if (prompt) prompt.after(fieldset);
        } else {
          this.fieldsetHome.after(prompt || fieldset);
          if (prompt) prompt.after(fieldset);
        }
        this.classList.toggle('is-fieldset-relocated', Boolean(moveBelowImage));
      };
      this.positionFieldset();
      this.mobileQuery.addEventListener('change', this.positionFieldset);
      const requestedValue = portrait === 'multi-pet' ? (this.usesNativeVariants ? 'Multi-Pet' : 'Multi-Pet Portrait') : portrait === 'pet-human' ? (this.usesNativeVariants ? 'Pet & Human' : 'Pet & Human Portrait') : '';
      if (requestedValue) {
        const input = Array.from(this.inputs).find((item) => item.value === requestedValue);
        if (input) input.checked = true;
      }
      this.inputs.forEach((input) => input.addEventListener('change', () => {
        if (this.usesNativeVariants) this.selectNativePortraitType(input.value);
        else {
          this.updateExample(input.value);
          this.syncSubjectMinimum(input.value);
        }
      }));
      if (this.usesNativeVariants) {
        this.variantPicker?.addEventListener('change', (event) => {
          if (!event.target?.matches?.('input[type="radio"]') || !/^\d+$/.test(event.target.value)) return;
          this.refreshNativeInputs();
          this.applyNativeSubjectRules(this.nativeTypeInputs.find((input) => input.checked)?.value || 'Multi-Pet');
          document.querySelector('pawty-portrait-details-v2')?.updateUploadSlots?.(true);
        }, true);
        this.variantPicker?.addEventListener('change', () => {
          window.requestAnimationFrame(() => this.syncFromNativeVariant());
          window.setTimeout(() => this.syncNativeProductState(), 700);
        });
        this.syncFromNativeVariant(true);
      }
      const selected = Array.from(this.inputs).find((input) => input.checked) || this.inputs[0];
      if (selected) {
        selected.checked = true;
        if (!this.usesNativeVariants) {
          if (this.isCreateYourOwn && !requestedValue) this.showCreateOwnImage();
          else this.updateExample(selected.value);
          this.syncSubjectMinimum(selected.value, true);
        }
      }
    }

    selectNativePortraitType(value) {
      this.refreshNativeInputs();
      const wantedSubjects = value === 'Single Pet / Memorial' ? '1' : (this.nativeSubjectInputs.find((input) => input.checked)?.value === '1' ? '2' : null);
      if (wantedSubjects) {
        const subjectInput = this.nativeSubjectInputs.find((input) => input.value === wantedSubjects);
        if (subjectInput) subjectInput.checked = true;
      }
      const nativeType = this.nativeTypeInputs.find((input) => input.value === value);
      if (nativeType && !nativeType.checked) nativeType.click();
      window.requestAnimationFrame(() => this.applyNativeSubjectRules(value));
    }

    syncFromNativeVariant(initial = false) {
      this.refreshNativeInputs();
      const selectedType = this.nativeTypeInputs.find((input) => input.checked)?.value || 'Multi-Pet';
      const customInput = Array.from(this.inputs).find((input) => input.value === selectedType);
      if (customInput) customInput.checked = true;
      this.applyNativeSubjectRules(selectedType, initial);
    }

    applyNativeSubjectRules(value, initial = false) {
      this.refreshNativeInputs();
      const isSingle = value === 'Single Pet / Memorial';
      const allowed = isSingle ? ['1'] : ['2', '3', '4', '5', '6'];
      const current = this.nativeSubjectInputs.find((input) => input.checked);
      this.nativeSubjectInputs.forEach((input) => {
        input.closest('label')?.toggleAttribute('hidden', !allowed.includes(input.value));
      });
      this.variantPicker?.classList.toggle('is-single-subject', isSingle);
      this.querySelector('[data-single-status]')?.toggleAttribute('hidden', !isSingle);
      const guidance = isSingle ? this.settings.singleGuidance : value === 'Pet & Human' ? this.settings.humanGuidance : this.settings.multiGuidance;
      const guidanceElement = this.querySelector('[data-subject-guidance]');
      if (guidanceElement) guidanceElement.textContent = guidance;
      if (!allowed.includes(current?.value || '')) {
        const wanted = isSingle ? '1' : '2';
        const target = this.nativeSubjectInputs.find((input) => input.value === wanted);
        if (target && !target.checked) target.click();
      }
      this.syncNativeProductState();
    }

    syncNativeProductState() {
      if (!this.usesNativeVariants || !this.nativeVariants?.length) return;
      const portraitType = this.nativeTypeInputs.find((input) => input.checked)?.value;
      const subjects = this.nativeSubjectInputs.find((input) => input.checked)?.value;
      const variant = this.nativeVariants.find((item) => item.portraitType === portraitType && item.subjects === subjects);
      if (!variant) return;
      document.querySelectorAll('form[action*="/cart/add"] input[name="id"]').forEach((input) => {
        input.value = String(variant.id);
      });
      const productInformation = this.closest('.product-information') || document.querySelector('[data-testid="product-information"]');
      productInformation?.querySelectorAll('product-price [ref="priceContainer"] .price').forEach((price) => {
        price.textContent = variant.price;
      });
      const url = new URL(window.location.href);
      url.searchParams.set('variant', String(variant.id));
      if (url.href !== window.location.href) history.replaceState({}, '', url);
    }

    refreshNativeInputs() {
      this.nativeTypeInputs = Array.from(this.variantPicker?.querySelectorAll('input[type="radio"]') || []).filter((input) => ['Multi-Pet', 'Pet & Human', 'Single Pet / Memorial'].includes(input.value));
      this.nativeSubjectInputs = Array.from(this.variantPicker?.querySelectorAll('input[type="radio"]') || []).filter((input) => /^\d+$/.test(input.value));
    }

    showCreateOwnImage() {
      if (!this.viewer) return;
      const image = this.viewer.querySelector('img');
      if (this.settings.createOwnImage) image.src = this.settings.createOwnImage;
      image.alt = this.settings.createOwnLabel || 'Your Idea, Made Into Art';
      this.viewer.querySelector('.pawty-media-switcher__label').textContent = this.settings.createOwnLabel || 'Your Idea, Made Into Art';
    }

    syncSubjectMinimum(value, initial = false) {
      const wanted = value === 'Single Pet / Memorial Portrait' ? '1' : '2';
      const optionInputs = Array.from(document.querySelectorAll('variant-picker input[type="radio"]'));
      const current = optionInputs.find((input) => input.checked);
      if (value !== 'Single Pet / Memorial Portrait' && Number(current?.value || 0) >= 2) return;
      if (initial && new URLSearchParams(window.location.search).has('variant')) return;
      const target = optionInputs.find((input) => String(input.value).match(/\d+/)?.[0] === wanted);
      if (target && !target.checked) target.click();
    }

    setupInspiration(fieldset) {
      const key = new URLSearchParams(window.location.search).get('inspiration');
      const entry = key ? this.querySelector(`.pawty-inspiration-data [data-key="${CSS.escape(key)}"]`) : null;
      if (!entry) return;
      this.inspirationEntry = entry;
      if (this.galleryInvite) this.galleryInvite.hidden = true;
      const productForm = fieldset.querySelector('input[form]')?.getAttribute('form');
      this.inspirationCard = document.createElement('aside');
      this.inspirationCard.className = 'pawty-inspiration';
      this.inspirationCard.innerHTML = `
        <div class="pawty-inspiration__copy"><small>${this.inspirationSettings.selectedLabel}</small><strong>${entry.dataset.title}</strong><p>${this.inspirationSettings.explanation}</p></div>
        <div class="pawty-inspiration__actions"><a class="pawty-inspiration__change" href="${this.inspirationSettings.galleryLink}">${this.inspirationSettings.changeLabel}</a><button class="pawty-inspiration__remove" type="button">${this.inspirationSettings.removeLabel}</button></div>
        <input type="hidden" name="properties[Inspired by]" value="${entry.dataset.title}">
        <input type="hidden" name="properties[_Inspiration image]" value="${entry.dataset.thumbnail || entry.dataset.image}">
        <input type="hidden" name="properties[_Inspiration key]" value="${entry.dataset.key}">
      `;
      this.inspirationCard.querySelectorAll('input').forEach((input) => input.setAttribute('form', productForm));
      this.inspirationCard.querySelector('.pawty-inspiration__remove').addEventListener('click', () => {
        const url = new URL(window.location.href);
        url.searchParams.delete('inspiration');
        history.replaceState({}, '', url);
        this.inspirationCard.remove();
        this.inspirationCard = null;
        this.inspirationEntry = null;
        if (this.galleryInvite) {
          this.galleryInvite.hidden = false;
          fieldset.before(this.galleryInvite);
        }
        const selected = Array.from(this.inputs).find((input) => input.checked) || this.inputs[0];
        if (selected) this.updateExample(selected.value);
        this.positionFieldset();
      });
      this.fieldsetHome.after(this.inspirationCard);
      if (!new URLSearchParams(window.location.search).has('portrait')) {
        const wantedValue = entry.dataset.type === 'pet-human' ? 'Pet & Human Portrait' : 'Multi-Pet Portrait';
        const input = Array.from(this.inputs).find((item) => item.value === wantedValue);
        if (input) input.checked = true;
      }
    }

    disconnectedCallback() {
      this.mobileQuery?.removeEventListener('change', this.positionFieldset);
    }

    updateExample(value) {
      if (!this.viewer) return;
      const isHuman = value === 'Pet & Human Portrait';
      const src = this.inspirationEntry?.dataset.image || (isHuman ? this.settings.humanImage : this.settings.multiImage);
      const label = this.inspirationEntry ? this.inspirationSettings.selectedImageLabel : (isHuman ? this.settings.humanLabel : this.settings.multiLabel);
      const image = this.viewer.querySelector('img');
      if (src) image.src = src;
      image.alt = label;
      this.viewer.querySelector('.pawty-media-switcher__label').textContent = label;
    }
  });
}

const initPawtyFamilyPhotoIntake = (intake, endpoint) => {
  if (!intake || intake.pawtyFamilyPhoto) return intake?.pawtyFamilyPhoto;
  const modeInputs = Array.from(intake.querySelectorAll('[data-family-photo-mode]'));
  const input = intake.querySelector('[data-family-photo-input]');
  const panel = intake.querySelector('[data-family-upload-panel]');
  const photoCount = intake.querySelector('[data-family-photo-count]');
  const triggerLabel = intake.querySelector('[data-family-photo-trigger-label]');
  const error = intake.querySelector('[data-family-photo-error]');
  const list = intake.querySelector('[data-family-photo-list]');
  const propertyHost = intake.querySelector('[data-family-photo-properties]');
  const confirmation = intake.querySelector('[data-family-photo-switch]');
  const add = intake.querySelector('[data-family-photo-add]');
  const keep = intake.querySelector('[data-family-photo-keep]');
  const clear = intake.querySelector('[data-family-photo-clear]');
  const formId = input?.getAttribute('form') || '';
  let entries = [];
  let pending = 0;
  let replaceIndex = null;
  const selectedMode = () => modeInputs.find((mode) => mode.checked)?.value || 'later';
  const clearError = () => { if (error) { error.hidden = true; error.textContent = ''; } };
  const renderProperties = () => {
    if (!propertyHost) return;
    propertyHost.replaceChildren();
    const timing = document.createElement('input');
    timing.type = 'hidden';
    timing.name = 'properties[_Photo timing]';
    timing.value = entries.length ? 'Uploaded now' : 'After checkout';
    if (formId) timing.setAttribute('form', formId);
    propertyHost.append(timing);
    entries.forEach((entry, index) => {
      if (!entry.url) return;
      const hidden = document.createElement('input');
      hidden.type = 'hidden';
      hidden.name = `properties[_Reference photo ${index + 1}]`;
      hidden.value = entry.url;
      if (formId) hidden.setAttribute('form', formId);
      propertyHost.append(hidden);
    });
  };
  const renderList = () => {
    if (!list) return;
    list.replaceChildren();
    entries.forEach((entry, index) => {
      const item = document.createElement('li');
      item.className = 'pawty-family-photo-intake__photo';
      const image = document.createElement('img');
      image.alt = `Family photo ${index + 1}`;
      image.src = entry.preview;
      const label = document.createElement('span');
      label.textContent = entry.url ? `Photo ${index + 1}` : `Uploading photo ${index + 1}`;
      const controls = document.createElement('div');
      const remove = document.createElement('button');
      remove.type = 'button';
      remove.textContent = 'Remove photo';
      remove.disabled = !entry.url;
      remove.addEventListener('click', () => {
        if (entry.preview) URL.revokeObjectURL(entry.preview);
        entries.splice(index, 1);
        render();
      });
      controls.append(remove);
      item.append(image, label, controls);
      list.append(item);
    });
  };
  const render = () => {
    const mode = selectedMode();
    intake.dataset.photoMode = mode;
    intake.dataset.photoCount = String(entries.filter((entry) => entry.url).length);
    intake.dataset.photoUploading = pending ? 'true' : 'false';
    panel?.toggleAttribute('hidden', mode !== 'now');
    const uploaded = entries.filter((entry) => entry.url).length;
    if (triggerLabel) triggerLabel.textContent = uploaded ? 'Add more photos' : 'Choose photos';
    if (photoCount) photoCount.textContent = uploaded ? `${uploaded} photo${uploaded === 1 ? '' : 's'} added` : '';
    renderProperties();
    renderList();
  };
  const upload = async (file, index) => {
    const entry = { preview: URL.createObjectURL(file), url: '' };
    if (index === null) entries.push(entry);
    else entries.splice(index, 0, entry);
    pending += 1;
    render();
    try {
      const body = new FormData();
      body.append('file', file);
      const response = await fetch(`${String(endpoint || '').replace(/\/$/, '')}/upload`, { method: 'POST', headers: { Accept: 'application/json' }, body });
      const payload = await response.json();
      if (!response.ok || !payload?.file?.url) throw new Error(payload?.error || 'Photo upload could not be completed.');
      entry.url = payload.file.url;
      clearError();
      return entry;
    } catch (uploadError) {
      const currentIndex = entries.indexOf(entry);
      if (currentIndex >= 0) entries.splice(currentIndex, 1);
      if (entry.preview) URL.revokeObjectURL(entry.preview);
      if (error) { error.hidden = false; error.textContent = uploadError.message || 'Photo upload could not be completed.'; }
      return null;
    } finally {
      pending = Math.max(0, pending - 1);
      render();
    }
  };
  const selectFiles = async () => {
    const files = Array.from(input?.files || []);
    input.value = '';
    const available = Math.max(0, 8 - entries.length);
    const chosen = files.slice(0, replaceIndex === null ? available : 1);
    if (!chosen.length) return;
    const requestedReplace = replaceIndex;
    replaceIndex = null;
    if (requestedReplace !== null) {
      const current = entries[requestedReplace];
      const replacement = await upload(chosen[0], null);
      if (replacement && current) {
        const replacementIndex = entries.indexOf(replacement);
        if (replacementIndex >= 0) entries.splice(replacementIndex, 1);
        const currentIndex = entries.indexOf(current);
        if (currentIndex >= 0) entries.splice(currentIndex, 1);
        if (current.preview) URL.revokeObjectURL(current.preview);
        entries.splice(requestedReplace, 0, replacement);
        render();
      }
    } else {
      for (const file of chosen) await upload(file, null);
    }
  };
  const clearPhotos = () => {
    entries.forEach((entry) => { if (entry.preview) URL.revokeObjectURL(entry.preview); });
    entries = [];
    pending = 0;
    confirmation?.setAttribute('hidden', '');
    const later = modeInputs.find((mode) => mode.value === 'later');
    if (later) later.checked = true;
    clearError();
    render();
  };
  const validate = () => {
    if (selectedMode() !== 'now' || entries.some((entry) => entry.url)) return pending === 0;
    if (error) { error.hidden = false; error.textContent = 'Add at least one photo, or choose Send them after checkout.'; }
    intake.open = true;
    input?.focus();
    return false;
  };
  modeInputs.forEach((mode) => mode.addEventListener('change', () => {
    if (mode.value === 'later' && entries.length) {
      const now = modeInputs.find((item) => item.value === 'now');
      if (now) now.checked = true;
      confirmation?.removeAttribute('hidden');
    } else {
      confirmation?.setAttribute('hidden', '');
    }
    clearError();
    render();
  }));
  input?.addEventListener('change', selectFiles);
  add?.addEventListener('click', () => input?.click());
  keep?.addEventListener('click', () => confirmation?.setAttribute('hidden', ''));
  clear?.addEventListener('click', clearPhotos);
  intake.pawtyFamilyPhoto = {
    validate,
    isReady: () => pending === 0,
    properties: () => {
      const properties = { '_Photo timing': entries.some((entry) => entry.url) ? 'Uploaded now' : 'After checkout' };
      entries.forEach((entry, index) => { if (entry.url) properties[`_Reference photo ${index + 1}`] = entry.url; });
      return properties;
    },
    hasPhotos: () => entries.some((entry) => entry.url),
  };
  render();
  return intake.pawtyFamilyPhoto;
};

if (!customElements.get('pawty-portrait-details-v2')) {
  customElements.define('pawty-portrait-details-v2', class extends HTMLElement {
    connectedCallback() {
      this.config = this.querySelector('.pawty-details')?.dataset || this.dataset;
      const stickyAdd = document.querySelector('sticky-add-to-cart');
      if (stickyAdd) stickyAdd.style.setProperty('display', 'none', 'important');
      this.pendingUploads = 0;
      this.directOrderMode = this.config.directOrderMode === 'true';
      this.classicSingleArtworkMode = this.config.classicSingleArtworkMode === 'true';
      this.petHumanDirectMode = this.config.petHumanDirectMode === 'true';
      if (this.directOrderMode) {
        const productInformation = this.closest('.product-information') || document.querySelector('[data-testid="product-information"]');
        productInformation?.classList.add('pawty-direct-pdp');
        const title = productInformation?.querySelector('h1');
        const eyebrow = this.querySelector('.pawty-direct-order__eyebrow');
        if (title && eyebrow) title.before(eyebrow);
        const related = this.querySelector('.pawty-direct-related');
        if (productInformation && related) productInformation.after(related);
      }
      this.subjectCount = Number(this.config.defaultSubjects || 2);
      try {
        this.variantData = JSON.parse(this.querySelector('[data-pawty-detail-variants]')?.textContent || '[]');
      } catch (_) {
        this.variantData = [];
      }
      this.form = document.getElementById(this.querySelector('input[type="file"]')?.getAttribute('form'));
      this.photoIntake = this.querySelector('[data-family-photo-intake]');
      this.familyPhotoController = initPawtyFamilyPhotoIntake(this.photoIntake, this.config.uploadEndpoint);
      this.status = document.createElement('p');
      this.status.className = 'pawty-details__upload-status';
      this.status.setAttribute('role', 'status');
      (this.querySelector('[data-family-photo-feedback]') || this.querySelector('.pawty-details__uploads'))?.after(this.status);
      const themeProductWrapper = this.form?.closest('product-form-component');
      if (themeProductWrapper && this.form) themeProductWrapper.replaceWith(this.form);
      this.submitButton = this.directOrderMode
        ? this.querySelector('[data-pawty-direct-submit]')
        : this.form?.querySelector('[type="submit"]');
      if (this.submitButton) {
        const themeAddWrapper = this.submitButton.closest('add-to-cart-component');
        if (themeAddWrapper) themeAddWrapper.replaceWith(this.submitButton);
        this.submitButton.type = 'button';
        const handleAdd = async (event) => {
          event.preventDefault();
          event.stopImmediatePropagation();
          if (this.directOrderMode && !this.classicSingleArtworkMode && !this.familyPhotoController?.validate()) return;
          if (!this.uploadsReady()) {
            this.status.textContent = this.config.waitLabel;
            return;
          }
          await this.addToCart();
        };
        this.submitButton.addEventListener('click', handleAdd, true);
        this.submitButton.addEventListener('keydown', async (event) => {
          if (event.key === 'Enter' || event.key === ' ') await handleAdd(event);
        }, true);
      }
      this.form?.addEventListener('submit', async (event) => {
        if (this.directOrderMode && !this.classicSingleArtworkMode && !this.familyPhotoController?.validate()) return;
        if (!this.uploadsReady()) {
          event.preventDefault();
          event.stopImmediatePropagation();
          this.status.textContent = this.config.waitLabel;
          return;
        }
        event.preventDefault();
        event.stopImmediatePropagation();
        await this.addToCart();
      }, true);
      this.uploadInputs = Array.from(this.querySelectorAll('input[type="file"]:not([data-family-photo-input])'));
      this.readyPanel = this.querySelector('[data-pawty-ready]');
      this.readyMessage = this.querySelector('[data-pawty-ready-message]');
      this.summarySubjects = this.querySelector('[data-pawty-summary-subjects]');
      this.summaryPrice = this.querySelector('[data-pawty-summary-price]');
      this.paymentPanel = this.querySelector('[data-pawty-payment]');
      this.paymentInputs = Array.from(this.querySelectorAll('input[name="pawty-payment-plan"]'));
      this.fullPaymentLabel = this.querySelector('[data-pawty-full-label]');
      this.depositHelp = this.querySelector('[data-pawty-deposit-help]');
      this.fullTotal = this.querySelector('[data-pawty-full-total]');
      this.payToday = this.querySelector('[data-pawty-pay-today]');
      this.balance = this.querySelector('[data-pawty-balance]');
      this.paymentStatus = this.querySelector('[data-pawty-payment-status]');
      this.directSubjects = this.querySelector('[data-pawty-direct-subjects]');
      this.directPeople = this.querySelector('[data-pawty-direct-people]');
      this.directPets = this.querySelector('[data-pawty-direct-pets]');
      this.directFull = this.querySelector('[data-pawty-direct-full]');
      this.directBalance = this.querySelector('[data-pawty-direct-balance]');
      this.familyMembers = this.querySelector('[data-pawty-family-members]');
      this.familyCollections = Array.from(this.querySelectorAll('input[name^="family-session-collection-"]'));
      this.familyIncluded = this.querySelector('[data-family-included]');
      this.familyLooks = this.querySelector('[data-family-looks]');
      this.familyGallery = this.querySelector('[data-family-gallery]');
      this.artworkChoices = Array.from(this.querySelectorAll('[data-artwork-choice]'));
      this.singleArtwork = this.querySelector('[data-single-artwork]')?.dataset.singleArtwork || '';
      this.artworkCount = this.querySelector('[data-artwork-count]');
      this.artworkFull = this.querySelector('[data-artwork-full]');
      this.artworkPaid = this.querySelector('[data-artwork-paid]');
      this.artworkBalance = this.querySelector('[data-artwork-balance]');
      this.artworkSavings = this.querySelector('[data-artwork-savings]');
      this.artworkDecrease = this.querySelector('[data-artwork-quantity-decrease]');
      this.artworkIncrease = this.querySelector('[data-artwork-quantity-increase]');
      this.artworkChoices.forEach((choice) => choice.addEventListener('change', () => {
        if (this.artworkChoices.length === 1 && !choice.checked) choice.checked = true;
        this.artworkChoices.forEach((item) => {
          const state = item.closest('.pawty-artwork-choice')?.querySelector('[data-choice-state]');
          if (state) state.textContent = item.checked ? 'Selected' : 'Select';
        });
        this.updateDirectSummary();
        this.syncSubmitState();
      }));
      if (this.artworkChoices.length) {
        fetch('/cart.js', { headers: { Accept: 'application/json' } }).then((response) => response.json()).then((cart) => {
          const existing = new Set((cart.items || []).filter((item) => String(item.product_id) === String(this.config.productId)).map((item) => item.properties?.['Artwork choice']).filter(Boolean));
          this.artworkChoices.forEach((choice) => {
            if (!existing.has(choice.value)) return;
            choice.checked = false;
            choice.disabled = true;
            const state = choice.closest('.pawty-artwork-choice')?.querySelector('[data-choice-state]');
            if (state) state.textContent = 'Added';
          });
          if (this.artworkChoices.length === 1 && !this.artworkChoices.some((choice) => choice.checked && !choice.disabled)) {
            const available = this.artworkChoices.find((choice) => !choice.disabled);
            if (available) available.checked = true;
          }
          this.updateDirectSummary();
        }).catch(() => {});
      }
      this.familyMembers?.addEventListener('change', () => this.updateDirectSummary());
      this.familyCollections.forEach((input) => input.addEventListener('change', () => this.updateDirectSummary()));
      this.directSubjects?.addEventListener('change', () => {
        this.updateDirectSummary();
        this.syncSubmitState();
      });
      [this.directPeople, this.directPets].forEach((input) => input?.addEventListener('change', () => {
        this.updateDirectSummary();
        this.syncSubmitState();
      }));
      this.paymentInputs.forEach((input) => input.addEventListener('change', () => {
        this.updatePaymentSummary();
        this.syncSubmitState();
        this.dispatchPaymentPlanEvent();
      }));
      this.uploadInputs.forEach((input) => {
        input.addEventListener('change', async () => {
          const label = input.closest('.pawty-upload');
          const text = label.querySelector('small');
          label.querySelector('input[type="hidden"]')?.remove();
          label.querySelector('.pawty-upload__preview')?.remove();
          label.querySelector('.pawty-upload__remove')?.remove();
          label.classList.remove('is-filled', 'is-error');
          if (input.files.length > 0) {
            const originalFile = input.files[0];
            text.dataset.originalLabel = text.dataset.originalLabel || text.textContent;
            text.textContent = this.config.preparingLabel;
            label.classList.add('is-uploading');
            this.pendingUploads += 1;
            this.syncSubmitState();
            const uploadSequence = String(Number(input.dataset.uploadSequence || 0) + 1);
            input.dataset.uploadSequence = uploadSequence;
            let localUrl = '';
            const image = document.createElement('img');
            image.className = 'pawty-upload__preview';
            image.alt = '';
            try {
              const optimizedFile = await this.optimizePhoto(originalFile);
              if (input.dataset.uploadSequence !== uploadSequence) return;
              if (optimizedFile !== originalFile && 'DataTransfer' in window) {
                const transfer = new DataTransfer();
                transfer.items.add(optimizedFile);
                input.files = transfer.files;
              }
              localUrl = URL.createObjectURL(input.files[0]);
              image.src = localUrl;
              label.append(image);
              text.textContent = this.config.uploadingLabel;
              const uploaded = await this.uploadPhoto(input.files[0], (progress) => {
                text.textContent = progress < 100 ? `${this.config.uploadingLabel} ${progress}%` : this.config.processingLabel;
              });
              if (input.dataset.uploadSequence !== uploadSequence) return;
              const hidden = document.createElement('input');
              hidden.type = 'hidden';
              hidden.name = input.dataset.propertyName;
              hidden.value = uploaded.url;
              hidden.setAttribute('form', input.getAttribute('form'));
              hidden.dataset.shopifyFileId = uploaded.id;
              label.append(hidden);
              label.classList.add('is-filled');
              text.textContent = this.config.uploadedLabel;
              this.updateUploadSlots();
            } catch (error) {
              console.warn('[pawty-upload]', error);
              label.classList.add('is-error');
              text.textContent = this.config.failedLabel;
            } finally {
              label.classList.remove('is-uploading');
              this.pendingUploads = Math.max(0, this.pendingUploads - 1);
              this.syncSubmitState();
            }
            const remove = document.createElement('button');
            remove.type = 'button';
            remove.className = 'pawty-upload__remove';
            remove.setAttribute('aria-label', this.config.removeLabel);
            remove.textContent = '×';
            remove.addEventListener('click', (event) => {
              event.preventDefault();
              event.stopPropagation();
              if (localUrl) URL.revokeObjectURL(localUrl);
              input.value = '';
              label.classList.remove('is-filled', 'is-error', 'is-uploading');
              label.querySelector('input[type="hidden"]')?.remove();
              image.remove();
              remove.remove();
              text.textContent = text.dataset.originalLabel;
              this.updateUploadSlots();
            });
            label.append(remove);
          }
        });
      });
      this.variantPicker = document.querySelector('variant-picker');
      this.variantPicker?.addEventListener('change', (event) => {
        if (event.target?.matches?.('input[type="radio"], select')) {
          window.requestAnimationFrame(() => {
            this.updateUploadSlots(true);
            this.syncSelectedVariant();
          });
        }
      });
      this.updateUploadSlots();
      this.syncSelectedVariant(true);
      this.updateDirectSummary();
    }

    getSelectedPortraitType() {
      const nativeType = Array.from(this.variantPicker?.querySelectorAll('input[type="radio"]') || [])
        .find((input) => input.checked && ['Multi-Pet', 'Pet & Human', 'Single Pet / Memorial'].includes(input.value));
      if (nativeType) return nativeType.value;
      const propertyType = this.form?.querySelector('[name="properties[Portrait type]"]')?.value || '';
      if (propertyType.startsWith('Multi-Pet')) return 'Multi-Pet';
      if (propertyType.startsWith('Pet & Human')) return 'Pet & Human';
      if (propertyType.startsWith('Single Pet')) return 'Single Pet / Memorial';
      return '';
    }

    syncSelectedVariant(skipUrl = false) {
      if (!this.variantData?.length || !this.form) return null;
      if (this.directOrderMode) {
        const id = this.config.directVariantId;
        const variant = this.variantData.find((item) => String(item.id) === String(id) && Number(item.priceCents) === 1000);
        this.currentVariant = variant || null;
        return variant || null;
      }
      const subjects = String(this.getSelectedSubjectCount());
      const portraitType = this.getSelectedPortraitType();
      const variant = this.variantData.find((item) => {
        if (String(item.subjects) !== subjects) return false;
        return !item.portraitType || !portraitType || item.portraitType === portraitType;
      });
      if (!variant) return null;

      this.form.querySelectorAll('input[name="id"]').forEach((input) => {
        input.value = String(variant.id);
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
      const productInformation = this.closest('.product-information') || document.querySelector('[data-testid="product-information"]');
      productInformation?.querySelectorAll('product-price [ref="priceContainer"] .price').forEach((price) => {
        price.textContent = variant.price;
      });
      this.updateReadySummary(variant);
      if (!skipUrl) {
        const url = new URL(window.location.href);
        url.searchParams.set('variant', String(variant.id));
        if (url.href !== window.location.href) history.replaceState({}, '', url);
      }
      return variant;
    }

    getSelectedSubjectCount() {
      if (this.directOrderMode) return Number(this.directSubjects?.value || 0);
      const controls = Array.from(this.variantPicker?.querySelectorAll('input[type="radio"], select') || []);
      for (const control of controls) {
        if (control.tagName === 'INPUT' && !control.checked) continue;
        const value = control.value || control.options?.[control.selectedIndex]?.value || '';
        const match = String(value).match(/\d+/);
        if (match) return Math.min(6, Math.max(1, Number(match[0])));
      }
      return this.subjectCount || 2;
    }

    updateUploadSlots(announceRetained = false) {
      if (this.directOrderMode) {
        this.subjectCount = Number(this.directSubjects?.value || 0);
        this.uploadInputs.forEach((input, zeroIndex) => {
          const label = input.closest('.pawty-upload');
          const filled = label?.classList.contains('is-filled');
          const show = zeroIndex < 2 || filled || (zeroIndex === 2 && this.uploadInputs.slice(0, 2).some((item) => item.closest('.pawty-upload')?.classList.contains('is-filled')));
          input.required = false;
          label?.toggleAttribute('hidden', !show);
        });
        this.syncSubmitState();
        return;
      }
      const previousCount = this.subjectCount;
      this.subjectCount = this.getSelectedSubjectCount();
      const requiredReady = this.uploadInputs.slice(0, this.subjectCount).every((input) => input.closest('.pawty-upload')?.classList.contains('is-filled'));
      this.uploadInputs.forEach((input, zeroIndex) => {
        const slot = zeroIndex + 1;
        const label = input.closest('.pawty-upload');
        const text = label?.querySelector('small');
        const filled = label?.classList.contains('is-filled');
        const isRequired = slot <= this.subjectCount;
        const previousOptionalFilled = slot === this.subjectCount + 1 || this.uploadInputs[zeroIndex - 1]?.closest('.pawty-upload')?.classList.contains('is-filled');
        const showOptional = requiredReady && slot > this.subjectCount && previousOptionalFilled;
        input.required = isRequired;
        label?.toggleAttribute('hidden', !isRequired && !filled && !showOptional);
        if (text && !label.classList.contains('is-uploading')) {
          const requiredLabel = (this.config.requiredPhotoLabel || 'Subject {number} photo · required').replace('{number}', slot);
          const nextLabel = isRequired ? requiredLabel : (this.config.optionalPhotoLabel || 'Add another reference · optional');
          text.dataset.originalLabel = nextLabel;
          if (!filled && !label.classList.contains('is-error')) text.textContent = nextLabel;
        }
      });
      if (announceRetained && this.subjectCount < previousCount && this.uploadInputs.slice(this.subjectCount).some((input) => input.closest('.pawty-upload')?.classList.contains('is-filled'))) {
        this.status.textContent = this.config.extraKeptLabel;
      }
      this.updateReadySummary();
      this.syncSubmitState();
    }

    updateReadySummary(knownVariant = null) {
      if (!this.readyPanel) return;
      const requiredInputs = this.uploadInputs?.slice(0, this.subjectCount) || [];
      const ready = requiredInputs.length === this.subjectCount && requiredInputs.every((input) => input.closest('.pawty-upload')?.classList.contains('is-filled'));
      this.readyPanel.hidden = !ready;
      if (!ready) return;

      const portraitType = this.getSelectedPortraitType();
      const subjectNoun = portraitType === 'Multi-Pet' ? (this.subjectCount === 1 ? 'pet' : 'pets') : (this.subjectCount === 1 ? 'subject' : 'subjects');
      const variant = knownVariant || this.variantData.find((item) => {
        if (String(item.subjects) !== String(this.subjectCount)) return false;
        return !item.portraitType || !portraitType || item.portraitType === portraitType;
      });
      if (this.readyMessage) this.readyMessage.textContent = (this.config.readyLabel || 'All {count} reference photos are ready.').replace('{count}', this.subjectCount);
      if (this.summarySubjects) this.summarySubjects.textContent = `${this.subjectCount} ${subjectNoun}`;
      if (this.summaryPrice) this.summaryPrice.textContent = variant?.price || '';
      this.currentVariant = variant || null;
      const depositEligible = this.subjectCount >= 1 && this.subjectCount <= 6;
      this.paymentPanel?.toggleAttribute('hidden', !depositEligible);
      if (!depositEligible) {
        const fullInput = this.paymentInputs?.find((input) => input.value === 'full');
        if (fullInput) fullInput.checked = true;
      }
      this.updatePaymentSummary();
    }

    getPaymentPlan() {
      return this.paymentInputs?.find((input) => input.checked)?.value || 'full';
    }

    moneyFromCents(cents) {
      return new Intl.NumberFormat(document.documentElement.lang || 'en-US', {
        style: 'currency',
        currency: window.Shopify?.currency?.active || 'USD',
        minimumFractionDigits: 0,
        maximumFractionDigits: 2,
      }).format(Number(cents || 0) / 100);
    }

    updatePaymentSummary() {
      if (!this.currentVariant) return;
      const fullCents = Number(this.currentVariant.priceCents || 0);
      const plan = this.getPaymentPlan();
      const payTodayCents = plan === 'deposit' ? 1000 : fullCents;
      const balanceCents = Math.max(0, fullCents - payTodayCents);
      const depositBalanceCents = Math.max(0, fullCents - 1000);
      const fullMoney = this.moneyFromCents(fullCents);
      const payTodayMoney = this.moneyFromCents(payTodayCents);
      const balanceMoney = this.moneyFromCents(balanceCents);
      const depositBalanceMoney = this.moneyFromCents(depositBalanceCents);
      if (this.fullPaymentLabel) this.fullPaymentLabel.textContent = `${this.config.fullPaymentLabel} — ${fullMoney}`;
      if (this.depositHelp) {
        this.depositHelp.textContent = (this.config.depositHelpTemplate || '')
          .replaceAll('{full_total}', fullMoney)
          .replaceAll('{balance}', depositBalanceMoney);
      }
      if (this.fullTotal) this.fullTotal.textContent = fullMoney;
      if (this.payToday) this.payToday.textContent = payTodayMoney;
      if (this.balance) this.balance.textContent = balanceMoney;
      if (this.paymentStatus) {
        this.paymentStatus.textContent = plan === 'deposit' && !this.config.depositVariantId ? this.config.depositUnavailableLabel : '';
      }
    }

    directFullCents() {
      if (this.directOrderMode) {
        if (this.singleArtwork) return 3900;
        const count = this.artworkChoices?.filter((choice) => choice.checked).length || 0;
        if (this.artworkChoices?.length > 1 && count === 0) return false;
        if (count === 1) return 3900;
        if (count === 2) return 6900;
        return 8900 + (count - 3) * 2900;
      }
      const familyMembers = Number(this.familyMembers?.value || 0);
      if (familyMembers >= 1 && familyMembers <= 6) {
        const base = familyMembers <= 2 ? 2000 : (familyMembers - 1) * 2000;
        const portraitCollection = this.familyCollections?.find((input) => input.checked)?.value || 'hero';
        return base + (portraitCollection === 'story' ? 7900 : portraitCollection === 'signature' ? 3900 : 0);
      }
      let subjects = Number(this.directSubjects?.value || 0);
      if (this.petHumanDirectMode) {
        const people = Number(this.directPeople?.value || 0);
        const pets = Number(this.directPets?.value || 0);
        if (!people || !pets) return 0;
        subjects = people + pets;
        if (subjects < 2 || subjects > 6) return 0;
      }
      if (!subjects) return 0;
      if (subjects <= 2) return 2000;
      return (subjects - 1) * 2000;
    }

    updateDirectSummary() {
      if (!this.directOrderMode) return;
      if (this.classicSingleArtworkMode) {
        if (this.submitButton) this.submitButton.textContent = 'Start this artwork — $10';
        return;
      }
      const fullCents = this.directFullCents();
      const artworkCount = this.singleArtwork ? 1 : (this.artworkChoices?.filter((choice) => choice.checked).length || 0);
      if (this.artworkChoices?.length > 1 && artworkCount === 0) {
        if (this.artworkFull) this.artworkFull.textContent = '—';
        if (this.artworkPaid) this.artworkPaid.textContent = '—';
        if (this.artworkBalance) this.artworkBalance.textContent = '—';
        if (this.artworkSavings) this.artworkSavings.textContent = '—';
        if (this.artworkCount) this.artworkCount.textContent = '0';
        if (this.submitButton) {
          this.submitButton.disabled = true;
          this.submitButton.textContent = 'Choose an artwork to continue';
        }
        return;
      }
      const paidCents = artworkCount * 1000;
      const savingsCents = Math.max(0, artworkCount * 3900 - fullCents);
      if (this.artworkFull) this.artworkFull.textContent = this.moneyFromCents(fullCents);
      if (this.artworkPaid) this.artworkPaid.textContent = this.moneyFromCents(paidCents);
      if (this.artworkBalance) this.artworkBalance.textContent = this.moneyFromCents(Math.max(0, fullCents - paidCents));
      if (this.artworkSavings) this.artworkSavings.textContent = this.moneyFromCents(savingsCents);
      if (this.artworkCount) this.artworkCount.textContent = String(artworkCount);
      if (this.submitButton) this.submitButton.textContent = this.singleArtwork || this.artworkChoices?.length === 1
        ? `Start this artwork — ${this.moneyFromCents(paidCents)}`
        : `Start ${artworkCount} artwork${artworkCount === 1 ? '' : 's'} — ${this.moneyFromCents(paidCents)}`;
      if (this.submitButton) this.submitButton.disabled = false;
      const portraitCollection = this.familyCollections?.find((input) => input.checked)?.value || 'hero';
      if (this.directFull) this.directFull.textContent = fullCents ? this.moneyFromCents(fullCents) : 'Confirm after details';
      if (this.directBalance) this.directBalance.textContent = fullCents ? this.moneyFromCents(Math.max(0, fullCents - 1000)) : 'Confirm after details';
      if (this.familyIncluded) this.familyIncluded.textContent = portraitCollection === 'story' ? '5' : portraitCollection === 'signature' ? '3' : '1';
      if (this.familyLooks) this.familyLooks.textContent = portraitCollection === 'story' ? '2' : '1';
      if (this.familyGallery) this.familyGallery.textContent = portraitCollection === 'story' ? '8–10 proofs' : portraitCollection === 'signature' ? '6–8 proofs' : '1 Hero Proof';
    }

    dispatchPaymentPlanEvent() {
      if (!this.currentVariant) return;
      const fullTotal = Number(this.currentVariant.priceCents || 0) / 100;
      const paymentPlan = this.getPaymentPlan();
      const payToday = paymentPlan === 'deposit' ? 10 : fullTotal;
      document.dispatchEvent(new CustomEvent('pawty:payment-plan-selected', {
        detail: {
          payment_plan: paymentPlan,
          subjects: this.subjectCount,
          full_total: fullTotal,
          pay_today: payToday,
          remaining_balance: Math.max(0, fullTotal - payToday),
          product_id: this.config.productId,
          variant_id: this.currentVariant.id,
        },
      }));
    }

    syncSubmitState() {
      const button = this.submitButton || this.form?.querySelector('[type="submit"]');
      if (!button) return;
      button.toggleAttribute('aria-busy', this.pendingUploads > 0);
      const ready = this.uploadsReady();
      const depositUnavailable = this.getPaymentPlan() === 'deposit' && !this.config.depositVariantId;
      const directUnavailable = this.directOrderMode && Number(this.currentVariant?.priceCents || this.config.directVariantPrice || 0) !== 1000;
      button.disabled = !ready || depositUnavailable || directUnavailable;
      if (this.pendingUploads > 0) this.status.textContent = this.config.waitLabel;
      else if (directUnavailable) this.status.textContent = this.config.directUnavailableLabel;
      else if (!ready && !this.status.textContent) this.status.textContent = this.config.requiredGuidance;
      else if (ready && this.status.textContent === this.config.requiredGuidance) this.status.textContent = '';
    }

    uploadsReady() {
      if (this.directOrderMode) return this.pendingUploads === 0 && this.familyPhotoController?.isReady() !== false && !this.querySelector('.pawty-upload.is-error');
      const requiredInputs = this.uploadInputs?.filter((input) => input.required) || [];
      const requiredReady = requiredInputs.length > 0 && requiredInputs.every((input) => input.closest('.pawty-upload')?.classList.contains('is-filled'));
      return this.pendingUploads === 0 && requiredReady && !this.querySelector('.pawty-upload.is-error');
    }

    async uploadPhoto(file, onProgress) {
      const endpoint = this.config.uploadEndpoint.replace(/\/$/, '');
      const formData = new FormData();
      formData.append('file', file);
      return await new Promise((resolve, reject) => {
        const request = new XMLHttpRequest();
        request.open('POST', `${endpoint}/upload`);
        request.setRequestHeader('Accept', 'application/json');
        request.upload.addEventListener('progress', (event) => {
          if (event.lengthComputable) onProgress?.(Math.round((event.loaded / event.total) * 100));
        });
        request.addEventListener('load', () => {
          try {
            const payload = JSON.parse(request.responseText);
            if (request.status < 200 || request.status >= 300) throw new Error(payload.error || `Upload service error: ${request.status}`);
            resolve(payload.file);
          } catch (error) {
            reject(error);
          }
        });
        request.addEventListener('error', () => reject(new Error('Upload network error')));
        request.send(formData);
      });
    }

    async addToCart() {
      const button = this.submitButton || this.form?.querySelector('[type="submit"]');
      if (!this.form || !button || button.getAttribute('aria-busy') === 'true') return;
      button.setAttribute('aria-busy', 'true');
      button.disabled = true;
      const originalButtonLabel = button.textContent;
      if (this.directOrderMode) button.textContent = this.config.directAddingLabel || 'Adding…';
      this.status.textContent = '';
      try {
        const selectedVariant = this.syncSelectedVariant();
        if (this.directOrderMode) {
          if (!selectedVariant || Number(selectedVariant.priceCents || 0) !== 1000) {
            this.status.textContent = this.config.directUnavailableLabel;
            return;
          }
          const formData = new FormData(this.form);
          const currentCart = await fetch('/cart.js', { headers: { Accept: 'application/json' } }).then((response) => response.json());
          const existingChoices = new Set((currentCart.items || []).filter((item) => String(item.product_id) === String(this.config.productId)).map((item) => item.properties?.['Artwork choice']).filter(Boolean));
          const selectedChoices = this.classicSingleArtworkMode
            ? [{ value: '' }]
            : this.singleArtwork
              ? (existingChoices.has(this.singleArtwork) ? [] : [{ value: this.singleArtwork }])
              : (this.artworkChoices || []).filter((choice) => choice.checked && !existingChoices.has(choice.value));
          if (!this.classicSingleArtworkMode && !selectedChoices.length) throw new Error('Every selected artwork is already in the cart');
          const artworkQuantity = Math.max(1, selectedChoices.length);
          const fullCents = this.directFullCents();
          const familyMembers = Number(this.familyMembers?.value || 0);
          const portraitCollection = this.familyCollections?.find((input) => input.checked)?.value || 'hero';
          const includedFinals = portraitCollection === 'story' ? 5 : portraitCollection === 'signature' ? 3 : 1;
          const looks = portraitCollection === 'story' ? 2 : 1;
          const galleryProofs = portraitCollection === 'story' ? '8–10' : portraitCollection === 'signature' ? '6–8' : '1 Hero Proof';
          const people = Number(this.directPeople?.value || 0);
          const pets = Number(this.directPets?.value || 0);
          const subjects = familyMembers || (this.petHumanDirectMode ? (people && pets ? people + pets : 0) : Number(this.directSubjects?.value || 0));
          const creativeNote = String(this.form.querySelector('[name="properties[_Creative notes]"]')?.value || '').trim();
          formData.set('id', String(selectedVariant.id));
          formData.set('properties[_Selected style]', this.config.productTitle || 'Custom portrait');
          if (this.petHumanDirectMode) {
            formData.set('properties[_People count]', people ? String(people) : 'Pending after checkout');
            formData.set('properties[_Pet count]', pets ? String(pets) : 'Pending after checkout');
          }
          formData.set('properties[_Number of Subjects]', subjects ? String(subjects) : 'Pending after checkout');
          formData.set('properties[_Family members]', familyMembers ? String(familyMembers) : 'Pending after checkout');
          formData.set('properties[_Portrait collection]', portraitCollection);
          formData.set('properties[_Included finals]', String(includedFinals));
          formData.set('properties[_Looks]', String(looks));
          formData.set('properties[_Gallery proofs]', galleryProofs);
          formData.set('properties[_Order Journey]', this.petHumanDirectMode ? 'US$10 Pet & Human portrait start' : 'US$10 portrait start');
          formData.set('properties[_Detail Status]', subjects || people || pets || this.familyPhotoController?.hasPhotos() || creativeNote ? 'Partially supplied' : 'Awaiting customer details');
          if (creativeNote) formData.set('properties[_Creative notes]', creativeNote);
          else formData.delete('properties[_Creative notes]');
          formData.set('properties[_Pricing contract]', 'artwork_count_v1');
          formData.set('properties[_Artwork quantity]', '1');
          formData.set('properties[_Artwork unit]', 'Distinct finished artwork');
          formData.set('properties[_Full Portrait Total]', 'Calculated across eligible artworks in cart');
          formData.set('properties[_Paid Today]', this.moneyFromCents(artworkQuantity * 1000));
          formData.set('properties[_Remaining Balance]', 'Calculated across eligible artworks in cart');
          formData.set('properties[_Original product ID]', this.config.productId || '');
          formData.set('properties[_Original variant ID]', String(selectedVariant.id));
          formData.set('properties[_Original product handle]', this.config.productHandle || '');
          formData.set('properties[_Original image]', this.config.productImage || '');
          formData.set('properties[_Journey version]', 'unified_artwork_pricing_v1');
          const sharedProperties = {};
          formData.forEach((value, key) => {
            const match = key.match(/^properties\[(.+)\]$/);
            if (match && typeof value === 'string' && value) sharedProperties[match[1]] = value;
          });
          const items = selectedChoices.map((choice) => ({
            id: Number(selectedVariant.id),
            quantity: 1,
            properties: { ...sharedProperties, 'Artwork choice': choice.value },
          }));
          const response = await fetch(window.Theme?.routes?.cart_add_url || '/cart/add.js', {
            method: 'POST',
            headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
            body: JSON.stringify({ items, sections: 'cart-drawer-section', sections_url: window.location.pathname }),
          });
          const payload = await response.json();
          if (!response.ok) throw new Error(payload.description || payload.message || 'Add to cart failed');
          window.PawtyAnalytics?.trackAddToCart?.({
            id: selectedVariant.id,
            product_id: this.config.productId || '',
            product_handle: this.config.productHandle || '',
            price: 1000,
            quantity: artworkQuantity,
            journey: this.petHumanDirectMode ? 'pet_human_direct10' : 'direct10',
          });
          const sectionHtml = payload.sections?.['cart-drawer-section'];
          if (sectionHtml) {
            const parsed = new DOMParser().parseFromString(sectionHtml, 'text/html');
            const freshContent = parsed.querySelector('cart-drawer-component');
            const currentContent = document.querySelector('#cart-drawer cart-drawer-component');
            if (freshContent && currentContent) currentContent.innerHTML = freshContent.innerHTML;
          }
          const drawer = document.querySelector('theme-drawer#cart-drawer');
          button.textContent = this.config.directAddedLabel || 'Added to cart';
          this.status.textContent = '';
          if (typeof drawer?.open === 'function') drawer.open();
          window.setTimeout(() => {
            if (button.getAttribute('aria-busy') !== 'true') button.textContent = originalButtonLabel;
          }, 1400);
          return;
        }
        const paymentPlan = this.getPaymentPlan();
        if (paymentPlan === 'deposit' && !this.config.depositVariantId) {
          this.paymentStatus.textContent = this.config.depositUnavailableLabel;
          return;
        }
        const formData = new FormData(this.form);
        if (selectedVariant) formData.set('id', String(paymentPlan === 'deposit' ? this.config.depositVariantId : selectedVariant.id));
        if (paymentPlan === 'deposit' && selectedVariant) {
          const fullCents = Number(selectedVariant.priceCents || 0);
          const balanceCents = Math.max(0, fullCents - 1000);
          formData.set('properties[Selected style]', this.config.productTitle || 'Custom portrait');
          formData.set('properties[Number of Subjects]', String(this.subjectCount));
          formData.set('properties[Payment Plan]', 'Design deposit');
          formData.set('properties[Full Portrait Total]', this.moneyFromCents(fullCents));
          formData.set('properties[Paid Today]', this.moneyFromCents(1000));
          formData.set('properties[Remaining Balance]', this.moneyFromCents(balanceCents));
          formData.set('properties[_Original product ID]', this.config.productId || '');
          formData.set('properties[_Original variant ID]', String(selectedVariant.id));
          formData.set('properties[_Original product handle]', this.config.productHandle || '');
          formData.set('properties[_Original image]', this.config.productImage || '');
          formData.set('properties[_Deposit experiment version]', '20260827v1-universal-10');
        }
        formData.set('sections', 'cart-drawer-section');
        formData.set('sections_url', window.location.pathname);
        const response = await fetch(window.Theme?.routes?.cart_add_url || '/cart/add.js', {
          method: 'POST',
          headers: { Accept: 'application/json' },
          body: formData,
        });
        const payload = await response.json();
        if (!response.ok) throw new Error(payload.description || payload.message || 'Add to cart failed');
        // Keep fulfillment properties (photos, notes, and private references) out of analytics.
        window.PawtyAnalytics?.trackAddToCart?.({
          id: Number(selectedVariant?.id || formData.get('id') || 0),
          product_id: this.config.productId || '',
          product_handle: this.config.productHandle || '',
          price: Number(selectedVariant?.priceCents || 0),
          quantity: 1,
          journey: this.petHumanDirectMode ? 'pet_human_direct10' : 'portrait',
        });
        const sectionHtml = payload.sections?.['cart-drawer-section'];
        if (sectionHtml) {
          const parsed = new DOMParser().parseFromString(sectionHtml, 'text/html');
          const freshContent = parsed.querySelector('cart-drawer-component');
          const currentContent = document.querySelector('#cart-drawer cart-drawer-component');
          if (freshContent && currentContent) currentContent.innerHTML = freshContent.innerHTML;
        }
        const drawer = document.querySelector('theme-drawer#cart-drawer');
        if (typeof drawer?.open === 'function') drawer.open();
        else {
          const dialog = drawer?.querySelector('dialog');
          drawer?.setAttribute('open', '');
          if (dialog && !dialog.open) dialog.showModal();
        }
      } catch (error) {
        console.warn('[pawty-add-to-cart]', error);
        this.status.textContent = this.directOrderMode && error?.message === 'Every selected artwork is already in the cart'
          ? 'This artwork is already in your cart.'
          : this.config.addErrorLabel;
      } finally {
        if (this.directOrderMode && button.textContent !== (this.config.directAddedLabel || 'Added to cart')) button.textContent = originalButtonLabel;
        button.removeAttribute('aria-busy');
        this.syncSubmitState();
      }
    }

    async postJson(url, body) {
      const response = await fetch(url, {
        method: 'POST',
        headers: { 'content-type': 'application/json', accept: 'application/json' },
        body: JSON.stringify(body),
      });
      const payload = await response.json();
      if (!response.ok) throw new Error(payload.error || `Upload service error: ${response.status}`);
      return payload;
    }

    async optimizePhoto(file) {
      if (!file.type.startsWith('image/') || file.size < 650000 || !('createImageBitmap' in window)) return file;
      try {
        const bitmap = await createImageBitmap(file);
        const maxEdge = 2000;
        const scale = Math.min(1, maxEdge / Math.max(bitmap.width, bitmap.height));
        if (scale === 1) {
          bitmap.close();
          return file;
        }
        const canvas = document.createElement('canvas');
        canvas.width = Math.round(bitmap.width * scale);
        canvas.height = Math.round(bitmap.height * scale);
        canvas.getContext('2d', { alpha: false }).drawImage(bitmap, 0, 0, canvas.width, canvas.height);
        bitmap.close();
        const blob = await new Promise((resolve) => canvas.toBlob(resolve, 'image/jpeg', 0.84));
        if (!blob || blob.size >= file.size * 0.92) return file;
        const baseName = file.name.replace(/\.[^.]+$/, '');
        return new File([blob], `${baseName}-optimized.jpg`, { type: 'image/jpeg', lastModified: file.lastModified });
      } catch (_) {
        return file;
      }
    }
  });
}

if (!window.PawtyStoryRoute) {
  window.PawtyStoryRoute = true;
  const setupStoryRoute = (root) => {
    if (root.dataset.storyBound === 'true') return;
    const dialog = root.querySelector('[data-dialog]');
    const choices = Array.from(root.querySelectorAll('[data-choice]'));
    const submit = root.querySelector('[data-submit]');
    const status = root.querySelector('[data-status]');
    const entry = root.querySelector('[data-entry-summary]');
    const intake = root.querySelector('[data-story-photo-intake]');
    const count = root.querySelector('[data-count]');
    const fullTotal = root.querySelector('[data-full]');
    const today = root.querySelector('[data-today]');
    const balance = root.querySelector('[data-balance]');
    const open = root.querySelector('[data-open]');
    const close = root.querySelector('[data-close]');
    const required = { dialog, choices: choices.length ? choices : null, submit, status, entry, intake, count, fullTotal, today, balance, open, close };
    const missing = Object.entries(required).filter(([, value]) => !value).map(([name]) => name);
    if (missing.length) {
      root.dataset.storyBinding = `missing:${missing.join(',')}`;
      const attempts = Number(root.dataset.storyBindingAttempts || 0);
      if (attempts < 1) {
        root.dataset.storyBindingAttempts = String(attempts + 1);
        const retry = () => setupStoryRoute(root);
        if (typeof window.requestAnimationFrame === 'function') window.requestAnimationFrame(retry);
        else window.setTimeout(retry, 0);
      }
      return;
    }
    const familyPhotoController = initPawtyFamilyPhotoIntake(intake, root.dataset.uploadEndpoint);
    let pendingUploads = 0;
    const money = (cents) => `$${cents / 100}`;
    const full = (count) => count === 1 ? 3900 : count === 2 ? 6900 : 8900 + (count - 3) * 2900;
    const selected = () => choices.filter((choice) => choice.getAttribute('aria-pressed') === 'true' && !choice.dataset.inCart);
    const update = () => {
      const count = selected().length;
      const total = count ? full(count) : 0;
      required.count.textContent = String(count);
      required.fullTotal.textContent = count ? money(total) : '—';
      required.today.textContent = count ? money(count * 1000) : '—';
      required.balance.textContent = count ? money(total - count * 1000) : '—';
      entry.textContent = count ? `${count} selected · ${money(count * 1000)} today` : '0 selected · — today';
      submit.disabled = count === 0 || pendingUploads > 0;
      submit.textContent = count ? `Start ${count} artwork${count === 1 ? '' : 's'} — ${money(count * 1000)}` : 'Choose an artwork to continue';
    };
    const intakeProperties = () => {
      const properties = familyPhotoController?.properties?.() || { '_Photo timing': 'After checkout' };
      const note = String(intake?.querySelector('[name="properties[_Creative notes]"]')?.value || '').trim();
      if (note) properties['_Creative notes'] = note;
      properties['_Detail Status'] = familyPhotoController?.hasPhotos?.() || note ? 'Partially supplied' : 'Awaiting customer details';
      return properties;
    };
    const openArtworkDialog = () => {
      if (!familyPhotoController?.validate()) {
        if (intake) {
          intake.open = true;
          intake.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
        return;
      }
      if (dialog && !dialog.open) dialog.showModal();
    };
    required.open.addEventListener('click', openArtworkDialog);
    required.close.addEventListener('click', () => dialog.close());
    dialog.addEventListener('click', (event) => { if (event.target === dialog) dialog.close(); });
    choices.forEach((choice) => choice.addEventListener('click', () => {
      if (choice.dataset.inCart) return;
      choice.setAttribute('aria-pressed', choice.getAttribute('aria-pressed') === 'true' ? 'false' : 'true'); update();
    }));
    submit?.addEventListener('click', async () => {
      const picked = selected();
      if (!picked.length || pendingUploads) return;
      if (!familyPhotoController?.validate()) {
        dialog?.close();
        intake.open = true;
        intake.scrollIntoView({ behavior: 'smooth', block: 'center' });
        return;
      }
      submit.disabled = true; status.textContent = '';
      try {
        const details = intakeProperties();
        const items = picked.map((choice) => ({ id: Number(root.dataset.variantId), quantity: 1, properties: {
          'Artwork choice': choice.dataset.choice, '_Order Journey': 'US$10 portrait start', '_Pricing contract': 'artwork_count_v1', '_Artwork quantity': '1', '_Artwork unit': 'Distinct finished artwork', '_Journey version': 'visual_selection_v3', '_Selected style': root.dataset.productTitle || 'Every Pet We’ve Loved, Together', ...details,
        }}));
        const response = await fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items }) });
        if (!response.ok) throw new Error('Unable to add your selection. Please try again.');
        window.PawtyAnalytics?.trackAddToCart?.({
          variant_id: root.dataset.variantId,
          product_id: root.dataset.productId,
          product_title: root.dataset.productTitle || 'Every Pet We’ve Loved, Together',
          quantity: picked.length,
          final_price: 1000,
        });
        await new Promise((resolve) => window.setTimeout(resolve, 720));
        location.assign('/cart');
      } catch (error) {
        status.textContent = error.message || 'Unable to add your selection.'; update();
      }
    });
    root.dataset.storyBound = 'true';
    root.dataset.storyBinding = 'ready';
    root.removeAttribute('data-story-binding-attempts');
    fetch('/cart.js', { headers: { Accept: 'application/json' }, cache: 'no-store' }).then((response) => {
      if (!response.ok) throw new Error('Cart unavailable'); return response.json();
    }).then((cart) => {
      const existing = new Set((cart.items || []).filter((item) => String(item.product_id) === String(root.dataset.productId)).map((item) => item.properties?.['Artwork choice']).filter(Boolean));
      choices.forEach((choice) => {
        const inCart = existing.has(choice.dataset.choice);
        choice.classList.toggle('is-in-cart', inCart); choice.dataset.inCart = inCart ? 'true' : ''; choice.setAttribute('aria-disabled', String(inCart)); choice.querySelector('[data-in-cart]').hidden = !inCart;
      }); update();
    }).catch(() => {
      status.textContent = 'Cart status could not be checked. Please refresh before adding.';
      choices.forEach((choice) => { choice.setAttribute('aria-disabled', 'true'); choice.dataset.inCart = 'true'; }); update();
    });
  };
  if (!customElements.get('story-route')) {
    customElements.define('story-route', class extends HTMLElement {
      connectedCallback() { setupStoryRoute(this); }
    });
  }
  const startStoryRoutes = () => document.querySelectorAll('story-route').forEach(setupStoryRoute);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', startStoryRoutes, { once: true });
  else startStoryRoutes();
}
